import { useSelector } from "react-redux";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Avatar, Box, Button, Dialog, Fade, Typography } from "@mui/material";
import { alpha } from '@mui/material/styles';

// Export for testing
export const createHandleClose = (onClose) => (event, reason) => {
    if (reason !== "backdropClick") {
        onClose(event, reason);
    }
};

const LicenseLimitModal = ({ show, onClose }) => {
    const firstName = useSelector(state => state.auth?.userAccount?.givenName);
    const handleClose = createHandleClose(onClose);

    return (
        <Dialog
            open={show}
            onClose={handleClose}
            TransitionComponent={Fade}
            transitionDuration={400}
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                    overflow: 'hidden',
                    maxWidth: '500px',
                    width: '100%',
                    m: { xs: 1, sm: 2 },
                }
            }}
            sx={{ backdropFilter: "blur(5px)" }}
            aria-labelledby="license-limit-modal-title"
            aria-describedby="license-limit-modal-description"
        >
            {/* Top accent bar */}
            <Box sx={{
                height: 4,
                width: '100%',
                background: 'linear-gradient(90deg, #61892f 0%, #4f7027 100%)'
            }} />

            <Box sx={{ pt: 4, pb: 2, px: { xs: 2, sm: 3 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Avatar sx={{
                        bgcolor: alpha('#61892f', 0.1),
                        color: '#61892f',
                        mr: 2
                    }}>
                        <InfoOutlinedIcon />
                    </Avatar>
                    <Typography
                        id="license-limit-modal-title"
                        variant="h6"
                        fontWeight={700}
                        color="text.primary"
                    >
                        Requesting access is Temporarily Disabled
                    </Typography>
                </Box>

                <Box
                    sx={{
                        p: 2.5,
                        bgcolor: 'rgba(0,0,0,0.02)',
                        borderRadius: 1.5,
                        border: '1px solid rgba(0,0,0,0.08)',
                        mb: 3,
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.5
                    }}
                >
                    <Box>
                        <Typography
                            variant="body2"
                            sx={{ lineHeight: 1.6, color: 'black', fontSize: "15px", mb: 2 }}
                        >
                            Hi {firstName},
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ lineHeight: 1.6, color: 'black', fontSize: "14px", mb: 2 }}
                        >
                            Unfortunately we cannot add new accounts to our GitHub Enterprise at this time due to license limitations.

                            {/* Users with existing Deloitte GitHub Accounts can request to join additional organizations as usual. */}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ lineHeight: 1.6, color: 'black', fontSize: "14px", mb: 2 }}
                        >
                            The ability to request access to an organization will be restored soon.
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ lineHeight: 1.6, color: 'black', fontSize: "14px" }}
                        >
                            Appreciate your understanding in this matter.
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 1 }}>
                    <Button
                        variant="contained"
                        onClick={onClose}
                        sx={{
                            px: 3,
                            py: 1,
                            bgcolor: '#4f7027',
                            color: '#fff',
                            fontWeight: 600,
                            boxShadow: 'none',
                            '&:hover': {
                                bgcolor: '#35501a'
                            }
                        }}
                    >
                        OK
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
};

export default LicenseLimitModal;